<div class="report-tab report-preview-main">
    <gen-overlay-loader *ngIf="loading"></gen-overlay-loader>
    <div class="linkToEditableParts"></div>

    <div id="modalContainer" class="modal">
        <!-- Modal content -->
        <span class="modal-overlay-bg" id="modalOverlay"></span>
        <div class="modal-content modal-content-internals dynamic-component-content">
            <div class="dynamic-style">
                <ng-template #editForm></ng-template>
                <div [ngSwitch]="editableView">
                    <div *ngSwitchCase="'dynamicForm'">
                        <gen-dynamic-form
                                class="report-preview-dynamic-content"
                                [formName]="payload.formId"
                                [editMode]="payload.config.editMode"
                                [formVertical]="payload.config.formVertical"
                                [disabled]="payload.config.disabled"
                                [formData]="payload.resource"
                                [listenToDataChange]="true"
                                [updatedFieldsContext]="revisionDetails.revisionId"
                                [updatedFieldsContextType]="'WorkflowRevision'"
                                [submitted]="submitted"
                                [title]="payload.config.title"
                                (formInit)="nestedComponentLoaded()"
                                (formChange)="updateResource(payload.resource, $event.form)"
                        ></gen-dynamic-form>
                    </div>
                </div>
            </div>
            <div class="gen-report-modal-ok-div">
                <gen-button
                        class="gen-report-modal-button"
                        id="closeEditReportModal"
                        [text]="'OK' | translate"
                        (click)="updateReport()"></gen-button>
                <gen-button
                        class="gen-report-modal-button"
                        [type]="'quite'"
                        [text]="'Cancel' | translate"
                        (click)="dismiss()"></gen-button>
            </div>
        </div>
    </div>

    <div class="report-div page-padding" id="renderedReportDiv" #renderedReportDiv (click)="handleClick($event)"></div>

    <div class="checkbox-edit-report edit-report">
        <div *ngIf="isPerformerUserLoggedIn() && this.isActiveRevision()">
            <div  *ngIf="(isEditableReport || stopAction)">
                <input
                        [(ngModel)]="editReportToggle"
                        (change)="handleHover()"
                        genPermissionSchemaRestrict
                        type="checkbox"
                        id="editReportToggle"
                        name="selected"/>
                <label for="editReportToggle"></label>
            </div>

            <input *ngIf="isAddendumReportEnabled === false && stopAction == false"
                   (click)="releaseFinalReport()"
                   [disabled]="isProceedFinalReportButtonDisabled()"
                   [permissionSchemaKey]="'reportsWrite'"
                   genPermissionSchemaRestrict
                   class="btn btn-primary Marginbox__t-small"
                   type="button"
                   value="{{'Release final report' | translate}}" />

            <input *ngIf="isAddendumReportEnabled === false && stopAction == true"
                   (click)="releaseFinalReportForStopAction()"
                   [permissionSchemaKey]="'reportsWrite'"
                   genPermissionSchemaRestrict
                   class="btn btn-primary Marginbox__t-small"
                   type="button"
                   value="{{'Release final report' | translate}}" />

            <input *ngIf="isAddendumReportEnabled === true"
                   (click)="releaseAddendumReport()"
                   [permissionSchemaKey]="'reportsWrite'"
                   genPermissionSchemaRestrict
                   class="btn btn-primary Marginbox__t-small"
                   type="button"
                   value="{{'Create addendum report' | translate}}"/>
        </div>
    </div>
</div>
